export const REQUEST_SOURCE_HEADER = 'X-Request-Source'
export const SSR_HEADER = 'X-SSR'
